<template>
  <main-layout>
    <div class="middle" v-if="url">
      <iframe
        :src="url + '&platform=pc&background=transparent'"
        :width="widthW"
        :height="heightH"
        frameborder="no"
        allowfullscreen='true'
        border="0"
      ></iframe>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  name: "livePage",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.直播")
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      id: null,
      url: null,
      widthW: null,
      heightH: null
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getUrl();
    this.widthW = document.body.clientWidth;
    this.heightH = (document.body.clientWidth * 9) / 16;
  },
  methods: {
    getUrl() {
      this.$http.post("/api/bytedance/auth/" + this.id).then(res => {
        if (res.code === "OK") {
          this.url = res.data;
        }
      });
    }
  }
  // ,
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     if (from.path == "/login" && !localStorage.getItem("auth_token")) {
  //       vm.$router.go(-1);
  //     }
  //   });
  // }
};
</script>

<style lang="stylus" scoped>
.middle{
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/newLive/livePage.vue